module.exports = __webpack_public_path__ + "img/3화_10(2)_수정.e2a483e6.png";